import { SystemKey } from '../types/index.ts';

const OFFICIAL_PHONE = '553598377222';

const WHATSAPP_MESSAGES: Record<SystemKey, string> = {
  gerencial: 'Olá! Gostaria de conhecer o ERP Controle Mais Gerencial para minha empresa.',
  transportes: 'Olá! Gostaria de agendar uma demonstração do Controle Mais Cooperativas de Transportes.',
  rural: 'Olá! Gostaria de agendar uma demonstração do Controle Mais Rural (Gestão de Fazendas e Talhões).',
  adubacao: 'Olá! Gostaria de conhecer o Controle Mais Adubação Cafeeira e o comparador de fertilizantes.',
  todos: 'Olá! Gostaria de conhecer as soluções da Linha Controle Mais da RR Info.',
};

export function getWhatsAppUrl(system: SystemKey): string {
  const message = WHATSAPP_MESSAGES[system] || WHATSAPP_MESSAGES.gerencial;
  return `https://wa.me/${OFFICIAL_PHONE}?text=${encodeURIComponent(message)}`;
}

export function initWhatsAppRouter(): void {
  const systemSelector = document.getElementById('systemSelector') as HTMLSelectElement | null;
  const whatsappCtaBtn = document.getElementById('whatsappCtaBtn') as HTMLAnchorElement | null;

  if (!systemSelector || !whatsappCtaBtn) return;

  const updateLink = () => {
    const selected = (systemSelector.value as SystemKey) || 'gerencial';
    whatsappCtaBtn.href = getWhatsAppUrl(selected);
  };

  // Inicializar estado do link
  updateLink();

  systemSelector.addEventListener('change', updateLink);
}
